export default __webpack_public_path__ + "static/media/logo.24d2b7b4.png";